import Titleofsection from "./titleofsection";
import aboutImg from "../img/houseAboutus.jpeg";
import PagetransitionRight from "../pagetrantionRight";

export default function Aboutsection() {
  return (
    <div name="About">
      <div className="container">
        <PagetransitionRight>
          <Titleofsection
            title={"About"}
            spantitle={"Our Brand"}
            descreption={
              "Passionate About Properties , Dedicated To Your Vision"
            }
          />

          <div className="content">
            <div className="about-img">
              <img src={aboutImg} alt="" />
            </div>
            <div className="information">
              <div className="details">
                <div>
                  <h1>10+</h1>
                  <p>Years of Excellence</p>
                </div>
                <div>
                  <h1>12+</h1>
                  <p>Projects Completed</p>
                </div>
                <div>
                  <h1>20+</h1>
                  <p>Mn. Sq. Ft. Delivered</p>
                </div>
                <div>
                  <h1>25+</h1>
                  <p>Mn. Sq. Ft. Delivered</p>
                </div>
              </div>
              <div className="descreption">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book.
                </p>
              </div>
              <div className="btn">
                <button>Learn more</button>
              </div>
            </div>
          </div>
        </PagetransitionRight>
      </div>
    </div>
  );
}
